import React from 'react';

export const pageMeta = {
  "name": "JS 2009 (ES5)",
  "link": "/javascript/versions/es5"
};

export default function JavascriptVersionsEs5() {
  return (
    <div className="p-6 max-w-3xl mx-auto">
      <h2 className="text-2xl font-semibold mb-2">JS 2009 (ES5)</h2>
      <p>Route: /javascript/versions/es5</p>
      <h3 className="mt-4 font-medium">sub_content</h3>
      <pre>{JSON.stringify(pageMeta, null, 2)}</pre>
    </div>
  );
}
